/**
 * Checks if the provided login corresponds to a Copilot integration.
 *
 * @param login - The login string to check.
 * @returns True if the login is "copilot_swe_agent" or "copilot", otherwise false.
 */
export function isCopilot(login: string | null): boolean {
  const lowerCaseLogin = login?.toLocaleLowerCase()
  return lowerCaseLogin === 'copilot_swe_agent' || lowerCaseLogin === 'copilot'
}

/**
 * Checks if an assignee is any kind of agent (Copilot or third-party).
 */
export function isAnyAgent(assignee: {login: string; isAgent?: boolean}): boolean {
  return isCopilot(assignee.login) || !!assignee.isAgent
}
